import { createSelector } from 'reselect'

export const selectCommandsState = state => state.commandsTools

export const selectCommandsCommand = createSelector(selectCommandsState, data => data.command)

export const selectCommandsStoreData = createSelector(selectCommandsState, data => ({
  command: data.command,
  commandsList: data.commandsList,
  isLoadingList: Boolean(data.isLoadingList),
  listError: data.listError,
  output: data.output,
  isExecuting: Boolean(data.isExecuting),
  executeError: data.executeError,
  executeSuccess: Boolean(data.executeSuccess),
}))
